// packages/allma-admin-shell/src/features/executions/constants.ts

export const EXECUTIONS_LIST_QUERY_KEY = 'flowExecutions';
export const EXECUTION_DETAIL_QUERY_KEY = 'flowExecutionDetail';
export const BRANCH_STEPS_QUERY_KEY = 'flowExecutionBranchSteps';